"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.concat = exports.round = void 0;
const round = (value, decimals) => Math.round(value * 10 ** decimals) / 10 ** decimals;
exports.round = round;
const concat = (result, data) => {
    if (typeof data === 'string')
        result.push(data);
    else
        data.forEach(line => result.push(line));
};
exports.concat = concat;
//# sourceMappingURL=utilities.js.map